import { getTimeInDate } from './utils';

// constants for test runs
export const TEST_RUN_DETAIL = 'testRunDetail';
export const TEST_BUILD = 'testBuild';
export const START_TIME = 'startTime';
export const END_TIME = 'endTime';
export const TEST_RUN_ID = 'testRunId';
export const DEVICE_GROUP_ID = 'deviceGroupId';
export const DEVICE_GROUP_NAME = 'deviceGroupName';
export const DSN = 'dsn';
export const STATUS = 'status';
export const TEST_REQUESTER = 'testRequester';
export const TEST_TIMEOUT = 'testTimeout';
export const TEST_RESULT = 'testResult';
export const TEST_RUN_TYPE = 'testRunType';
export const TEST_RUN_TYPE_NAME = 'testRunTypeName';
export const TEST_TITLE = 'testTitle';
export const TEST_SUITE = 'testSuite';
export const RESERVATION_ID = 'reservationId';
export const KATS_TEST_RUN_TYPE = '4';
export const TEST_RUNT_TYPE_MAPPING = {
    1: 'Network traffic analysis',
    2: 'Package analysis',
    3: 'Network traffic and package analysis',
    4: 'Kats',
};
export const BUILD_FIREOS = 'buildFireOS';
export const BUILD_PROJECT = 'buildProject';
export const BUILD_TYPE = 'buildType';
export const BUILD_VARIANT = 'buildVariant';
export const BUILD_VERSION = 'buildVersion';

// visible columns
export const VISIBLE_COLUMNS_AS_REQUESTER = [
    TEST_RUN_ID,
    DEVICE_GROUP_NAME,
    TEST_TITLE,
    TEST_SUITE,
    RESERVATION_ID,
    TEST_RUN_TYPE_NAME,
    BUILD_PROJECT,
    STATUS,
    TEST_RESULT,
    START_TIME,
    END_TIME,
];
export const VISIBLE_COLUMNS_ALL = [...VISIBLE_COLUMNS_AS_REQUESTER, TEST_REQUESTER];

// table column definitions
export const SORTED_FILED = {
    id: START_TIME,
    header: 'Start time',
    cell: (e) => getTimeInDate(e.startTime),
    sortingField: START_TIME,
    width: 250,
};
export const TESTRUN_COLUMNS_DEFINITION = [
    {
        id: TEST_RUN_ID,
        header: 'Test run ID',
        cell: (e) => e.testRunId,
        sortingField: TEST_RUN_ID,
        width: 350,
    },
    {
        id: DEVICE_GROUP_NAME,
        header: 'Device group name',
        cell: (e) => e.deviceGroupName,
        sortingField: DEVICE_GROUP_NAME,
        width: 250,
    },
    {
        id: DEVICE_GROUP_ID,
        header: 'Device group ID',
        cell: (e) => e.deviceGroupId,
        sortingField: DEVICE_GROUP_ID,
        width: 300,
    },
    {
        id: TEST_TITLE,
        header: 'Title',
        cell: (e) => e.testTitle,
        sortingField: TEST_TITLE,
        width: 150,
    },
    {
        id: TEST_REQUESTER,
        header: 'Requester',
        cell: (e) => e.testRequester,
        sortingField: TEST_REQUESTER,
        width: 200,
    },
    {
        id: TEST_RUN_TYPE,
        header: 'Test type id',
        cell: (e) => e.testRunType,
        width: 150,
    },
    {
        id: TEST_RUN_TYPE_NAME,
        header: 'Test type',
        cell: (e) => e.testRunTypeName,
        width: 150,
    },
    {
        id: DSN,
        header: 'DSN',
        cell: (e) => e.dsn,
        sortingField: DSN,
        width: 200,
    },
    {
        id: BUILD_PROJECT,
        header: 'Build project',
        cell: (e) => e.buildProject,
        sortingField: BUILD_PROJECT,
        width: 250,
    },
    {
        id: BUILD_TYPE,
        header: 'Build type',
        cell: (e) => e.buildType,
        sortingField: BUILD_TYPE,
        width: 150,
    },
    {
        id: BUILD_VARIANT,
        header: 'Build variant',
        cell: (e) => e.buildVariant,
        sortingField: BUILD_VARIANT,
        width: 150,
    },
    {
        id: BUILD_VERSION,
        header: 'Build version',
        cell: (e) => e.buildVersion,
        sortingField: BUILD_VERSION,
        width: 150,
    },
    {
        id: BUILD_FIREOS,
        header: 'FireOS',
        cell: (e) => e.buildFireOS,
        sortingField: BUILD_FIREOS,
        width: 150,
    },
    {
        id: TEST_SUITE,
        header: 'Test suite',
        cell: (e) => e.testSuite,
        sortingField: TEST_SUITE,
        width: 150,
    },
    {
        id: RESERVATION_ID,
        header: 'Reservation ID',
        cell: (e) => e.reservationId,
        sortingField: RESERVATION_ID,
        width: 350,
    },
    {
        id: STATUS,
        header: 'Status',
        cell: (e) => e.status,
        sortingField: STATUS,
        width: 150,
    },
    {
        id: TEST_RESULT,
        header: 'Result',
        cell: (e) => e.testResult,
        sortingField: TEST_RESULT,
        width: 150,
    },
    SORTED_FILED,
    {
        id: END_TIME,
        header: 'End time',
        cell: (e) => getTimeInDate(e.endTime),
        sortingField: END_TIME,
        width: 250,
    },
    {
        id: TEST_TIMEOUT,
        header: 'Scheduled timeout (min)',
        cell: (e) => e.testTimeout,
        sortingField: TEST_TIMEOUT,
        width: 250,
    },
];

// table preferences settings
export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 test runs' },
            { value: 50, label: '50 test runs' },
            { value: 100, label: '100 test runs' },
        ],
    },
    visibleContentPreference: {
        title: 'Select visible columns',
        options: [
            {
                label: 'Main properties',
                options: TESTRUN_COLUMNS_DEFINITION.map(({ id, header }) => ({
                    id,
                    label: header,
                    editable: id !== 'id',
                })),
            },
        ],
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
                { label: 'First two columns', value: 2 },
            ],
        },
    },
};
